import React, { useEffect, useRef } from 'react';
import { Box, keyframes } from '@mui/system';
import { Message as MessageType } from '../hooks/useChat';
import Message from './Message';

interface ChatBoxProps {
    messages: MessageType[];
    loadingAnswer: boolean;
}

const bounce = keyframes`
    0%, 80%, 100% {
        transform: scale(0);
    }
    40% {
        transform: scale(1.0);
    }
`;

const TypingIndicator = () => (
    <Box sx={{
        display: 'flex',
        alignItems: 'flex-end',
        mb: 1.5,
        alignSelf: 'flex-start',
    }}>
        <Box sx={{
            px: 2,
            py: 1,
            borderRadius: '20px',
            bgcolor: 'background.paper',
            color: 'text.primary',
            borderBottomLeftRadius: '5px',
            boxShadow: 1,
            display: 'flex',
            alignItems: 'center',
        }}>
            <Box component="span" sx={{ height: 8, width: 8, mx: 0.25, bgcolor: 'grey.500', borderRadius: '50%', display: 'inline-block', animation: `${bounce} 1.4s infinite ease-in-out both`, animationDelay: '-0.32s' }} />
            <Box component="span" sx={{ height: 8, width: 8, mx: 0.25, bgcolor: 'grey.500', borderRadius: '50%', display: 'inline-block', animation: `${bounce} 1.4s infinite ease-in-out both`, animationDelay: '-0.16s' }} />
            <Box component="span" sx={{ height: 8, width: 8, mx: 0.25, bgcolor: 'grey.500', borderRadius: '50%', display: 'inline-block', animation: `${bounce} 1.4s infinite ease-in-out both` }} />
        </Box>
    </Box>
);


const ChatBox: React.FC<ChatBoxProps> = ({ messages, loadingAnswer }) => {
    const chatBoxRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chatBoxRef.current) {
            chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
        }
    }, [messages, loadingAnswer]);

    return (
        <Box ref={chatBoxRef} sx={{
            flexGrow: 1,
            overflowY: 'auto',
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
        }}>
            {messages.map((message, index) => (
                <Message key={index} message={message} />
            ))}
            {loadingAnswer && <TypingIndicator />}
        </Box>
    );
};

export default ChatBox;